import * as React from 'react';
import LogoutView from '../components/Logout';

/**
 * ログアウト画面
 * @param _ propsなし
 */
const Logout: React.FC<{}> = _ => (
	<React.Fragment>
		<LogoutView />
	</React.Fragment>
);

/**
 * ログアウト画面
 * @param _ propsなし
 */
export default Logout;



// WEBPACK FOOTER //
// ./src/pages/Logout.tsx